<template>
  <div :class="['tva-number-image-component', {'onlyImage' : !content.numbers}]">
    <div class="background-image">
      <TvaParallax
        :image="`${baseUrl}images/${content.img}${$retina ? '@2x' : ''}${$tvaMq === 'mobile' ? '_m' : ''}.jpg`"
        :speed="1.4"
        :ease="'0.4s'"
        :imagePosition="'50% 20%'"
      />
    </div>
    <div :class="['gradient-image']"></div>
    <div class="number-block" v-for="(element, index) in content.numbers" :key="index">
      <div class="numeri_overlay" v-html="element.number">{{element.number}}</div>
      <p v-html="element.text">{{element.text}}</p>
    </div>
  </div>
</template>
<script>
import TvaParallax from "../utilities/TvaParallax.vue";
export default {
  props: ["content", "active"],
  data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  },
  components: {
    TvaParallax
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/fonts.scss";
@import "../assets/scss/colors.scss";
@import "../assets/scss/bootstrap-grid.scss";
.tva-number-image-component {
  height: 700px;
  width: 100vw;
  margin: 6vw 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  overflow: hidden;
  &.onlyImage {
    .gradient-image {
      display: none;
    }
  }
  .background-image {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: -2;
  }
  .gradient-image {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: -1;
    background: linear-gradient(
      to right,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 0.5) 60%,
      rgba(0, 0, 0, 0) 80%
    );
  }
  .number-block {
    margin: 20px 5%;
    padding-left: 20px;
    border-left: solid 2px $eni-yellow;
    width: 15%;
    p {
      font-size: 16px;
      font-weight: 800;
      line-height: 20px;
      letter-spacing: 0.8px;
      color: #ffffff;
      margin-top: 10px;
    }
    .numeri_overlay {
      padding-top: 10px;
    }
  }
}
@media (max-width: 1024px) {
  .tva-number-image-component {
    &.onlyImage {
      height: 30vh;
      .gradient-image {
        display: none;
      }
    }
    height: 50vh;
    .gradient-image {
      background: linear-gradient(
        to right,
        rgba(0, 0, 0, 1) 0%,
        rgba(0, 0, 0, 0.5) 60%,
        rgba(0, 0, 0, 0) 80%
      );
    }
    .number-block {
      margin: 20px 50px;
      padding-left: 20px;
      width: 40%;
    }
  }
}
@media (max-width: 720px) {
  .tva-number-image-component {
    height: 80vh;
    background: black;
    justify-content: flex-end;
    padding: 30px 0;
    &.onlyImage {
      height: 200px;
      .gradient-image {
        display: none;
      }
      .background-image::after {
        background: none;
      }
    }
    .background-image {
      position: absolute;
      top: 0;
      left: 0;
      filter: none;
      background-repeat: no-repeat;
      background-size: cover !important;
      background-position: 0% 0% !important;
      width: 100vw;
      height: 200px;
      z-index: 3;
      &::after {
        content: "";
        position: absolute;
        bottom: -10px;
        left: 0;
        height: 100%;
        width: 100%;
        background: linear-gradient(
          to bottom,
          rgba(0, 0, 0, 0) 50%,
          rgba(0, 0, 0, 0.5) 80%,
          rgba(0, 0, 0, 1) 90%,
          rgba(0, 0, 0, 1) 100%
        );
      }
    }

    .gradient-image {
      background: unset;
    }
    .number-block {
      z-index: 3;
      margin: 10px 20px;
      padding-left: 10px;
      width: 90%;
    }
  }
}
</style>


